import React, { useEffect, useState } from "react";
import Card from "@mui/material/Card";
// Soft UI Dashboard PRO React components
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import { useAuth } from "CustomComponents/Authcontext";

// Soft UI Dashboard PRO React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "CustomViews/Components/Tables/DataTable";
// Data
import { useSelector, useDispatch } from "react-redux";
import Box from '@mui/material/Box';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDownload, faSearch } from '@fortawesome/free-solid-svg-icons'

import { addCollectionVehicle } from "CustomComponents/dataStore/actions";
import LinearProgress from '@mui/material/LinearProgress';
import SuiButton from "components/SuiButton";


function CollectionsVehicle() {
    const dd = useSelector((state) => state.AccountsCollectionVehicle);
    const dispatch = useDispatch();
    const [nextkey, setnextkey] = useState(0);
    const [messagttouser, setmessagttouser] = useState("Loading Data...");
    const [nexttoggle, setnexttoggle] = useState(true);
    const [sipnnershow, setspinnershow] = useState(false);
    const { currentUser } = useAuth();

    useEffect(() => {
        if (dd.arr.length === 0) {
            calldatasetApi(0);
        }
    }, []);
    async function calldataallRepeat(e) {
        if (e >= 10) {
            var da = "";
            if (dd.nextKey !== "") {
                da = dd.nextKey;
            } else {
                da = nextkey;
            }
            if (!nexttoggle) alert("No Data To Load");

            if (da !== null && nexttoggle) {
                da = await calldatasetApi(da, e);
            }
        }

    }
    const fileJson = (JSONData, ReportTitle, ShowLabel) => {
        var arrData = typeof JSONData != "object" ? JSON.parse(JSONData) : JSONData;
        var CSV = "";
        var datasest = [];
        datasest = arrData.map((data) => {
            if (data.last_paid_on) {
                data.last_paid_on = new Date(data.last_paid_on * 1000).toLocaleString("en-US", {
                    day: "numeric",
                    month: "numeric",
                    year: "numeric",
                    hour: "numeric",
                    minute: "numeric",
                    hour12: true,
                });
            }

            var temp = {
                "Vehicle number": data.vehicle_number,
                "Amount collected": data.amount_collected,
                "Amount due": data.amount_due,
                "Last paid on": data.last_paid_on,
                "Travelled today": data.travelled_today,
                "Travelled till date": data.travelled_till_date,
                "Rides till date": data.rides_till_date,
                "Rides today": data.rides_today,
                "Driver name": data.driver_name,
                "Driver email": data.driver_email,
                "dro name":data.dro_name,
            };
            return temp;
        });


        const items = datasest;
        const replacer = (key, value) => (value === null ? " " : value); // specify how you want to handle null values here
        const header = Object.keys(items[0]);
        CSV = [ShowLabel + ",",
        header.join(","), // header row first
        ...items.map((row) =>
            header
                .map((fieldName) => JSON.stringify(row[fieldName], replacer))
                .join(",")
        ),
        ].join("\r\n");
        return CSV
    };
    async function calldatasetApi(nexttokenparam, limit = 100) {
        setspinnershow(true);
        if (nexttokenparam === undefined) {
            nexttokenparam = dd.nextKey || nextkey;
        }
        var myHeaders = new Headers();
        myHeaders.append(
            "Authorization",
            "Bearer " + currentUser.accessToken
        );

        var requestOptions = {
            method: "GET",
            headers: myHeaders,
            redirect: "follow",
        };
        return await fetch(
            process.env.REACT_APP_BASE_URL + "/accounts?type=collections&sub_type=vehicles&start=" +
            nexttokenparam + '&limit=' + limit,
            requestOptions
        )
            .then((response) => response.json())
            .then((result) => {
                if (result.status === true && result.data.length !== 0) {
                    result.data.map((dat) => {
                        if (dat.last_paid_on !== null) {
                            dat.last_paid_on = new Date(dat.last_paid_on * 1000).toLocaleString("en-US", {
                                day: "numeric",
                                month: "numeric",
                                year: "numeric",
                                hour: "numeric",
                                minute: "numeric",
                                hour12: true,
                            });

                        }
                        dat.travelled_today = dat.travelled_today.toFixed(2);
                        dat.travelled_till_date = dat.travelled_till_date.toFixed(2)
                    })
                    dispatch(addCollectionVehicle(result.data, result.start));
                    setnextkey(result.start);

                    setnexttoggle(true);
                    setspinnershow(false);
                    return result.start;
                } else {
                    setspinnershow(false);
                    setnexttoggle(false);
                    setmessagttouser("Unable to get data....ERROR : " + result.message);
                    console.log("error", result.message);
                    alert("No Data To Load");
                    return null;
                }
            })
            .catch((error) => {
                setspinnershow(false);
                setnexttoggle(false);
                setmessagttouser("Unable to get data....ERROR");
                console.log("error", error);
            });
    }
    function CSVDownload(params, name) {
        var CSV = params;
        if (CSV == "") {
            alert("Invalid data");
            return;
        }
        //Generate a file name
        var fileName = "Report_";
        //this will remove the blank-spaces from the title and replace it with an underscore
        fileName += name.replace(/ /g, "_");

        //Initialize file format you want csv or xls
        var uri = "data:text/csv;charset=utf-8," + escape(CSV);

        // Now the little tricky part.
        // you can use either>> window.open(uri);
        // but this will not work in some browsers
        // or you will not get the correct file extension

        //this trick will generate a temp <a /> tag
        var link = document.createElement("a");
        link.href = uri;

        //set the visibility hidden so it will not effect on your web-layout
        link.style = "visibility:hidden";
        link.download = fileName + ".csv";

        //this part will append the anchor tag and remove it after automatic click
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        // setisDisabled(false);
    }
    if (dd.arr.length === 0) {

        return (
            <DashboardLayout>
                <DashboardNavbar />
                <SuiBox pt={2} pb={3}>
                    <Card>
                        <SuiTypography variant="h6" sx={{ textAlign: 'center' }}>{messagttouser}</SuiTypography>
                    </Card>
                </SuiBox>
                <Footer />
            </DashboardLayout>
        );
    }
    return (
        <DashboardLayout>
            <DashboardNavbar />
            <SuiBox pt={2} pb={3}>
                <Card >
                    {sipnnershow && (
                        <Box sx={{ width: '100%', m: 0, p: 0 }}>
                            <LinearProgress color="success" sx={{ width: '100%' }} />
                        </Box>
                    )}
                    <SuiBox sx={{ mr: 2, mt: 1 }}>
                        <SuiButton sx={{ float: 'right' }} variant="gradient" onClick={() => {
                            var data = fileJson(dd.arr, 'CollectionDriver');
                            CSVDownload(data, 'CollectionDriver')
                        }} color="info"  >
                            <FontAwesomeIcon icon={faDownload} />
                        </SuiButton>
                    </SuiBox>
                    <DataTable table={dd.arr}
                        hidecolumnsdata={[]}
                        functioncallcount={calldataallRepeat}

                        datacolumns={[
                            {
                                Header: "vehicle number",
                                accessor: "vehicle_number",
                            },

                            {
                                Header: "Driver Name",
                                accessor: "driver_name",
                            },
                            {
                                Header: "Driver ID",
                                accessor: "driver_email",
                            },
                            {
                                Header: " Amount Paid",
                                accessor: "amount_collected",
                            },


                            {
                                Header: "Amount Due",
                                accessor: "amount_due",
                            },
                            {
                                Header: "distance travelled today (km)",
                                accessor: "travelled_today",
                            },
                            {
                                Header: "distance travelled till date (km)",
                                accessor: "travelled_till_date",
                            },
                            {
                                Header: " Number of rides",
                                accessor: "rides_till_date",
                            },
                            {
                                Header: "last paid on",
                                accessor: "last_paid_on",
                            },

                            // {
                            //   Header: "view more",
                            //   accessor: "action",
                            // },
                        ]}

                        canSearch />
                </Card>

            </SuiBox>
            <Footer />
        </DashboardLayout >
    );
}

export default CollectionsVehicle;
